import React, { ReactNode } from 'react'
import { useAtom } from 'jotai'
import { Control, UseFormSetValue } from 'react-hook-form'
import { InferType } from 'yup'
import { chatMessageSchema } from '../../../forms/schemas/chat_message'
import { RecipientRow } from '../../../generated/api/chat-recipients'
import { StartNewBoardChatHeader } from '../StartNewBoardChatHeader'
import { StartNewChatHeader } from '../StartNewChatHeader'
import { ChatHeaderState, chatHeaderStateAtom } from '../atom'

interface ChatHeaderProps {
  control: Control<InferType<typeof chatMessageSchema>>
  watchRecipients: RecipientRow[] | undefined
  watchSociety: string | undefined
  watchIsGroupchat: boolean
  setValue: UseFormSetValue<InferType<typeof chatMessageSchema>>
}

export const ChatHeader = ({
  control,
  watchRecipients,
  watchSociety,
  watchIsGroupchat,
  setValue,
}: ChatHeaderProps): ReactNode => {
  const [chatHeaderState] = useAtom(chatHeaderStateAtom)

  switch (chatHeaderState) {
    case ChatHeaderState.StartNewChat:
    case ChatHeaderState.StartNewInterestsChat:
      return (
        <StartNewChatHeader
          control={control}
          watchRecipients={watchRecipients}
          watchIsGroupchat={watchIsGroupchat}
          watchSociety={watchSociety}
          setValue={setValue}
        />
      )
    case ChatHeaderState.StartNewBoardChat:
      return <StartNewBoardChatHeader control={control} setValue={setValue} />
    default:
      return null
  }
}
